import { ChatSummaryStatus } from 'src/app/chats-panel/~store/models/enums/ChatSummaryStatus';
import './ChatSummaryStatusLabel.css';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useTranslation } from "react-i18next";

export interface IChatSummaryStatusProps {
  status: ChatSummaryStatus;
}

function ChatSummaryStatusLabel(props: IChatSummaryStatusProps) {

  const { t } = useTranslation();
  
  const _getStatusIcon = () => {
    return (
      <>
        {props.status === ChatSummaryStatus.InProgress &&
          <PendingActionsOutlinedIcon fontSize='small' className="chat-summary-status__status-icon" />}
        {props.status === ChatSummaryStatus.Failed &&
          <ErrorOutlineOutlinedIcon fontSize='small' className="chat-summary-status__status-icon" />}
        {props.status === ChatSummaryStatus.Completed &&
          <CheckCircleOutlineOutlinedIcon fontSize='small' className="chat-summary-status__status-icon" />}
      </>
    )
  }

  const _getStatusName = () => {
    switch (props.status) {
      case ChatSummaryStatus.InProgress:
        return t('chat.summaryInProgress');
      case ChatSummaryStatus.Failed:
        return t('chat.summaryFailed');
      case ChatSummaryStatus.Completed:
        return t('chat.summaryCompleted');
      default:
        return "";
    }
  }

  const _getStatusClass = () => {
    switch (props.status) {
      case ChatSummaryStatus.InProgress:
        return 'chat-summary-in-progress';
      case ChatSummaryStatus.Failed:
        return 'chat-summary-failed';
      case ChatSummaryStatus.Completed:
        return 'chat-summary-completed';
      default:
        return "";
    }
  }

  return (
    <div className={"chat-summary-status " + _getStatusClass()}>
      {_getStatusIcon()}
      <div className={'chat-summary-status__status-name ' + _getStatusClass}>{_getStatusName()}</div>
    </div>
  )
}

export default ChatSummaryStatusLabel;
